var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2928 4.707C18.3026 3.71681 16.6972 3.71681 15.707 4.707L13.707 6.707C12.9679 7.44608 12.7805 8.52791 13.1447 9.44083L14.7929 7.79275C15.1835 7.40224 15.8166 7.40226 16.2071 7.7928C16.5976 8.18333 16.5976 8.8165 16.2071 9.20701L14.5589 10.8551C15.4718 11.2193 16.5537 11.0319 17.2928 10.2928L19.2928 8.29278C20.283 7.3026 20.283 5.69718 19.2928 4.707ZM12.2928 5.29278C10.7645 6.82104 10.5549 9.16857 11.6638 10.9216L10.9216 11.6638C9.16854 10.5549 6.82103 10.7645 5.29278 12.2928L3.29278 14.2928C1.52155 16.064 1.52155 18.9358 3.29278 20.707C5.06402 22.4782 7.93576 22.4782 9.707 20.707L11.707 18.707C13.2353 17.1787 13.4449 14.831 12.3358 13.078L13.078 12.3358C14.8311 13.4449 17.1787 13.2353 18.707 11.707L20.707 9.707C22.4782 7.93576 22.4782 5.06402 20.707 3.29278C18.9358 1.52155 16.064 1.52155 14.2928 3.29278L12.2928 5.29278ZM9.44065 13.1446L7.79292 14.7923C7.40238 15.1828 7.40236 15.8159 7.79287 16.2065C8.18338 16.597 8.81654 16.597 9.20708 16.2065L10.855 14.5587C11.2193 15.4717 11.0319 16.5536 10.2928 17.2928L8.29278 19.2928C7.30259 20.283 5.69718 20.283 4.707 19.2928C3.71681 18.3026 3.71681 16.6972 4.707 15.707L6.707 13.707C7.44603 12.968 8.52777 12.7805 9.44065 13.1446Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLink);
export default __webpack_public_path__ + "static/media/ic_link.a94fad352879f2f9d07568c45952c90b.svg";
export { ForwardRef as ReactComponent };